//таблица на странице "Категории"
import { DeleteOutlined } from "@ant-design/icons";
import { Button, Popconfirm, Switch, Table, Tooltip } from "antd";
import Compact from "antd/es/space/Compact";
import { useEffect, useMemo, useState } from "react";
import EditCategory from "src/features/Modal/ui/EditCategory";
import { EditableCell, EditableRow, PhotoCell } from "src/shared";
import { setColumnCellProps } from "../lib/setCollumnCellProps";
import { COL_CATEGORIES } from "../model/constants";
import { apiRequests } from "src/shared/api/api";

export default function Categories({
  handleRemove,
  handleSave,
  dataSource,
  token,
  messageApi,
}) {
  const [parentNames, setParentNames] = useState({});

  useEffect(() => {
    const loadParents = async () => {
      if (!token || !Array.isArray(dataSource) || dataSource.length === 0) {
        return;
      }

      const parentIds = Array.from(
        new Set(
          dataSource
            .map((item) => item.parent)
            .filter((id) => id !== null && id !== undefined),
        ),
      );

      if (parentIds.length === 0) return;

      try {
        const results = await Promise.all(
          parentIds.map((id) =>
            apiRequests.categories
              .getItem(id, { token })
              .then((res) => res.data)
              .catch((error) => {
                console.error(`Error loading category parent ${id}:`, error);
                return null;
              }),
          ),
        );

        setParentNames((prev) => {
          const next = { ...prev };
          results
            .filter((item) => item && item.id && item.name)
            .forEach((item) => {
              next[item.id] = item.name;
            });
          return next;
        });
      } catch (error) {
        console.error("Error loading parent categories:", error);
      }
    };

    loadParents();
  }, [dataSource, token]);
  const columns = useMemo(
    () =>
      setColumnCellProps(COL_CATEGORIES, {
        image: [
          {
            key: "render",
            action: (_, record) => (
              <PhotoCell
                entity="categories"
                entityId={record.id}
                token={token}
                size={45}
                messageApi={messageApi}
              />
            ),
          },
        ],
        name: [
          {
            key: "render",
            action: (text) => (
              <Tooltip placement="topLeft" title={text} trigger={["hover"]}>
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {text}
                </span>
              </Tooltip>
            ),
          },
        ],
        description: [
          {
            key: "render",
            action: (text) => (
              <Tooltip placement="topLeft" title={text} trigger={["hover"]}>
                <span
                  style={{
                    display: "inline-block",
                    maxWidth: "100%",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {text}
                </span>
              </Tooltip>
            ),
          },
        ],
        parent: [
          {
            key: "render",
            action: (_value, record) => {
              if (record.parent === null || record.parent === undefined) {
                return null;
              }

              const parentName =
                parentNames[record.parent] ||
                record.parent_name ||
                record.parent;

              if (!parentName) return null;
              return (
                <Tooltip
                  placement="topLeft"
                  title={parentName}
                  trigger={["hover"]}
                >
                  <span
                    style={{
                      display: "inline-block",
                      maxWidth: "100%",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {parentName}
                  </span>
                </Tooltip>
              );
            },
          },
        ],
        status: [
          {
            key: "render",
            action: (checked, record) => (
              <>
                <Switch
                  checked={checked}
                  onChange={(checked) => {
                    record.status = checked;
                    handleSave(record);
                  }}
                />
              </>
            ),
          },
        ],
        action: [
          {
            key: "render",
            style: { padding: "0" },
            action: (_, record) => (
              <Compact
                style={{
                  padding: "0",
                }}
              >
                <EditCategory
                  record={record}
                  handleSave={handleSave}
                  token={token}
                />
                <Tooltip title={"Удалить категорию"} trigger={["hover"]}>
                  <Popconfirm
                    title={"Подтвердите удаление"}
                    onConfirm={() => handleRemove(record.id)}
                  >
                    <Button icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </Compact>
            ),
          },
          {
            key: "onCell",
            action: () => ({ style: { padding: 0 } }), // Убираем padding у ячеек колонки "Действие"
          },
        ],
      }),
    [handleRemove, handleSave, token, messageApi, parentNames]
  );

  return (
    <>
      <Table
        columns={columns}
        rowKey={(record) => record.id}
        dataSource={dataSource}
        components={{
          body: {
            cell: EditableCell,
            row: EditableRow,
          },
        }}
        bordered
        rowClassName={() => "editable-row"}
        style={{ width: "100%" }}
      />
    </>
  );
}
